module.exports = function getResource(label, vars = []) {
    const resources = {
        zeroResult: 'Sorry, we couldn’t find any results.',
        updateFilter: 'Try changing or clearing your filters.'
    };

    return resources[label];
};
